// IE 2026 09 28 / ODOO-5800 (поручение Игоря 28.09 «5 — делай ты»): ФОРМА НАСТРОЕК ВИДЖЕТА ПО ТРЕБОВАНИЮ.
//
// Замер ie-demo7 27.09 (Demo, бэк 1 CPU): ¾ времени каждого widget_open списка — сборка формы настроек (≈20 вкладок, 2,4–2,6 МБ из ~3 МБ ответа),
// а на странице настройки открывают редко. Фронт с этим флагом объявляет бэку client.settings_form_lazy (mainStore.client_requestParams), и
// widget_open списка / отчёта отдаёт КАРКАС формы: вкладки содержимого (таблица, график, карта, Гант, граф, сравнение) — как были, вкладки
// настроек — заголовками-заглушками (attrs: [], lazyForm: true; заголовок, иконка, use, бейджи, lazyMethod, id — те же). Полную форму фронт
// догружает методом виджета settings_form (mainStore.settingsForm_ensure) — один раз на виджет, до его перечитывания:
//   - при открытии вкладки-заглушки (AttrTabPanel: клик, переход по раскладке / selectTab / activeTab, оверлей и мобильный список вкладок);
//   - при переходе к узлу внутри неё (store.set_activeAttr: ⚙ легенды графика, «Params» чипсов, «Go to DL», источники правил оформления …);
//   - когда полоса вкладок видна (при открытии, Tabs, показ скрытых частей шапки, оверлей вкладок) — фоном, после основных запросов страницы:
//     бейджи вкладок настроек и скрытие пустых вкладок (режим Hide empty) остаются как были (fe.widget.settingsFormPrefetch).
// Ответ — view_patch узлов-заглушек (updateDoc); запись виджета не трогается (у фронта она новее: выборка, правки пользователя).
// Заглушка из ответа бэка никогда не затирает уже загруженную вкладку (mainStore.updateAttrs / applyViewPatch). После загрузки фронт шлёт
// settings_form_lazy: false — перечитывание (reload) сразу несёт полную форму.
//
// Выключатели (реестр feSettings, как остальные fe.*; ?fe.widget.settingsFormLazy=false в URL):
//   fe.widget.settingsFormLazy   (по умолчанию ВКЛ) — false: бэку не объявляется, форма приходит целиком в widget_open (прежнее поведение);
//   fe.widget.settingsFormPrefetch (по умолчанию ВКЛ) — false: при видимой полосе вкладок форма НЕ догружается фоном (бейджи и скрытие пустых
//                                  вкладок настроек — только после открытия настроек; быстрее, но полоса вкладок выглядит иначе).
// Бэк: выключатель not-settings_form_lazy (debug_flags запроса / params ПМ) — форма целиком и при объявленной поддержке.
// Консоль: window.settingsFormLazy.get() / .set('settingsFormLazy', false) / .reset() / .stats() / .clear() / .load(<id виджета>) / .help()
// Замеры (stats): открытия с каркасом и с полной формой, байты ответов widget_open, загрузки формы по причинам, их время (стена / бэк) и байты,
// ошибки, сколько раз заглушка из ответа не затёрла загруженную вкладку.

export const FLAG_LAZY = 'fe.widget.settingsFormLazy'
export const FLAG_WHOLE_VIEW_GUARD = 'fe.widget.settingsFormWholeViewGuard'   // IE 2026 10 10 / ODOO-341407: см. sfl_wholeViewPatch
export const FLAG_PREFETCH = 'fe.widget.settingsFormPrefetch'
const FLAGS = { settingsFormLazy: FLAG_LAZY, settingsFormPrefetch: FLAG_PREFETCH, settingsFormWholeViewGuard: FLAG_WHOLE_VIEW_GUARD }   // IE 2026 10 10 / ODOO-341407: + WholeViewGuard

const stats = {
    opensLazy: 0, opensLazyBytes: 0, opensLazyStubs: 0,   // ответы widget_open с каркасом: число, байты ответов, заглушек вкладок
    opensFull: 0, opensFullBytes: 0,                      // ответы widget_open списка / отчёта с полной формой (флаг выключен / бэк без поддержки)
    loads: 0, loadsMs: 0, loadsBackendMs: 0, loadsBytes: 0, loadsFailed: 0,   // догрузки формы (settings_form)
    loadsRoSkipped: 0,                                    // IE 2026 09 29 / ODOO-342781 (ревью F1): не отправлено — роль «только чтение», политика бэка метод не разрешает
    reasons: {},                                          // причина догрузки → число (tab, activeAttr, visible, hover, prefetch, console …)
    stubKept: 0,                                          // заглушка из ответа не затёрла загруженную вкладку
    wholeViewGuarded: 0, wholeViewRefused: 0,             // IE 2026 10 10 / ODOO-341407: ответ «вид целиком» сведён к вкладкам-заглушкам / не применён (sfl_wholeViewPatch)
}
const round = (x) => Math.round(x * 10) / 10

export function settingsFormLazy_on(store) {
    try { return !(store && typeof store.setting === 'function' && store.setting(FLAG_LAZY, true) === false) } catch (e) { return true }
}
export function settingsFormPrefetch_on(store) {
    try { return !(store && typeof store.setting === 'function' && store.setting(FLAG_PREFETCH, true) === false) } catch (e) { return true }
}

export function sfl_count(key, n = 1) {
    if (!(key in stats) || typeof stats[key] !== 'number') return
    stats[key] = round(stats[key] + n)
}
export function sfl_reason(reason) {
    const k = String(reason || '?')
    stats.reasons[k] = (stats.reasons[k] || 0) + 1
}

// IE 2026 09 29 / ODOO-342781 (ревью ie-dm7 F1): роль «только чтение» и политика бэка settings_form не разрешает — форму настроек фон (префетч, вкладка, ⚙ легенды) не шлём:
// без тоста (метод «тихий»: RO_QUIET_METHODS), состояние закрываем ошибкой — вкладка показывает «Could not load … click to retry» вместо вечного «Loading…»,
// промис не остаётся висеть (вызывающий получает false); повтор по клику спросит политику снова (она может смениться — другая база, ответ get_startup). Без роли
// readonly_deny всегда false — как было; стор без этого метода (тесты) — тоже. true — запрос запрещён (вызывающий выходит)
export function sfl_denyByRole(store, W) {
    if (!store || typeof store.readonly_deny !== 'function') return false
    if (!store.readonly_deny('executeWidgetMethod', 'settings_form')) return false
    if (W) { W._sflPrefetchQueued = false; W._sflState = 'error' }
    sfl_count('loadsRoSkipped')   // IE 2026 09 29 / ODOO-342781 (ревью F1): отдельный счётчик — это не сбой загрузки
    return true
}

// IE 2026 10 10 / ODOO-341407 (бой fe-2026-10-10-13, core #74843: страница, открытая на uk, — гриды на ~6-й секунде теряют колонки и пустеют;
// воспроизведено на dev02: живое переключение en→uk во время загрузки страницы, docs/uk_start_empty_grids_2026-10-10). Механизм: бэк settings_form
// сверяет заглушки фронта с заново собранной формой по settings_form_tab_ident = name || tooltip || TITLE; у вкладок без name (Source, Data layout
// schema, Row-View-list-fields …) это ЛОКАЛИЗОВАННЫЙ заголовок. Каркас, пришедший на одном языке (widget_open ушёл до переключения / relocalize
// перевёл заголовок иначе, чем бэк), не совпадает с формой бэка на другом — бэк отвечает «видом целиком» (whole_view), а фронт применял его
// updateAttrs(WIDGET.view, view) НА МЕСТЕ: узел грида данных (dataSheet) вкладки содержимого получал attrs из формы без выборки (колонки строит
// select) — массив колонок обнулялся, следующий content_Changed строил грид без колонок. Теперь (флаг fe.widget.settingsFormWholeViewGuard,
// дефолт ВКЛ) вид целиком сводится к патчу ТОЛЬКО вкладок-заглушек: пара по позиции (тот же состав вкладок: число и attr_type), иначе по name;
// вкладки содержимого (не заглушки) не трогаются никогда. Ничего не сопоставилось — null (ответ не применяется, вкладки остаются заглушками).
// feView / beView — WIDGET.view фронта и answer.view бэка. Возвращает [{ path: [0, i], node }] | null. Чистая функция — tests/unit/settingsFormWholeView.test.mjs
export function sfl_wholeViewPatch(feView, beView) {
    const fe = Array.isArray(feView) && feView[0] && Array.isArray(feView[0].attrs) ? feView[0].attrs : null
    const be = Array.isArray(beView) && beView[0] && Array.isArray(beView[0].attrs) ? beView[0].attrs : null
    if (!fe || !be) return null
    const ok = (t) => !!t && typeof t === 'object' && !t.lazyForm
    const sameShape = fe.length === be.length && fe.every((t, i) => t && be[i] && t.attr_type === be[i].attr_type)
    const byName = new Map()
    for (const t of be) if (ok(t) && typeof t.name === 'string' && t.name) byName.set(t.name, t)
    const patch = []
    fe.forEach((t, i) => {
        if (!t || !t.lazyForm) return
        let node = sameShape && ok(be[i]) ? be[i] : null
        if (!node && typeof t.name === 'string' && t.name) node = byName.get(t.name) || null
        if (node && node.attr_type === t.attr_type) patch.push({ path: [0, i], node })
    })
    return patch.length ? patch : null
}

// заглушки главной панели виджета (вкладки, чьё содержимое не пришло)
export function sfl_stubs(W) {
    try {
        const tp = (Array.isArray(W?.view) ? W.view : []).find(a => a?.attr_type === 'AttrTabPanel')
        return (tp?.attrs || []).filter(t => t && t.lazyForm)
    } catch (e) { return [] }
}

export function settingsFormLazy_console(store) {
    if (typeof window === 'undefined') return
    const flags = () => Object.fromEntries(Object.entries(FLAGS).map(([k, key]) => [k, store.setting(key, true) !== false]))
    window.settingsFormLazy = {
        flags: FLAGS,
        get: () => ({ ...flags(), stats: { ...stats, reasons: { ...stats.reasons } } }),
        set(name, value) {
            const key = FLAGS[name] || name
            if (!Object.values(FLAGS).includes(key)) return { error: `settingsFormLazy: no option '${name}'`, options: Object.keys(FLAGS) }
            window.feSettings?.set?.(key, value)
            return this.get()
        },
        reset() { for (const key of Object.values(FLAGS)) window.feSettings?.unset?.(key); return this.get() },
        stats: () => ({ ...stats, reasons: { ...stats.reasons } }),
        clear() { for (const k of Object.keys(stats)) stats[k] = k === 'reasons' ? {} : 0; return this.stats() },
        // догрузить форму виджета вручную: id виджета стора (WIDGET.id) либо id записи виджета (WIDGET.widget); без аргумента — активный виджет
        load(id) {
            const all = store.activeWORKSPACE?.ALL_WIDGETS || []
            const W = id == null ? store.activeWIDGET : (Array.isArray(all) ? all : Object.values(all)).find(x => x && (x.id === id || x.widget === id))
            if (!W) return { error: 'settingsFormLazy.load: widget not found' }
            store.settingsForm_ensure(W, 'console')
            return { widget: W.widget, stubs: sfl_stubs(W).length }
        },
        help: () => 'settingsFormLazy.set("settingsFormLazy" | "settingsFormPrefetch", false) — прежнее поведение (перезагрузить страницу); .reset() — снять override; .stats() / .clear() — счётчики; .load(id) — догрузить форму виджета',
    }
}
